var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer text-center"},[_vm._v("Copyright © 2017 TRADERS SECURITIES CO., LTD. All rights reserved.")])
}
var staticRenderFns = []

export { render, staticRenderFns }